<div class="zdb-card" [ngClass]="customClasses" [ngStyle]="customStyles">
  <ng-content select=".card-header"></ng-content>
  <ng-content select=".card-body"></ng-content>
  <ng-content select=".card-footer"></ng-content>
</div>
